import { useEffect, useState } from 'react'

import ApplicationUpdater from '../state/application/updater'
import UserUpdater from '../state/user/updater'
import { MulticallUpdater, TransactionUpdater } from '../domain'
import { DarkModeDocumentSync } from '../wallet'

/**
 * Retrasa updaters de polling hasta después del primer frame para no competir con el paint inicial.
 */
export default function DeferredAppUpdaters() {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let cancelled = false

    const activate = () => {
      if (!cancelled) setReady(true)
    }

    if (typeof window.requestIdleCallback === 'function') {
      const idleId = window.requestIdleCallback(activate, { timeout: 1200 })
      return () => {
        cancelled = true
        window.cancelIdleCallback(idleId)
      }
    }

    const timeoutId = window.setTimeout(activate, 32)
    return () => {
      cancelled = true
      window.clearTimeout(timeoutId)
    }
  }, [])

  if (!ready) return null

  return (
    <>
      <UserUpdater />
      <ApplicationUpdater />
      <TransactionUpdater />
      <MulticallUpdater />
      <DarkModeDocumentSync />
    </>
  )
}
